"use client"

const Card = ({ children, className = "", onClick }) => {
  return (
    <div
      className={`bg-white rounded-lg shadow-md p-6 ${onClick ? "cursor-pointer hover:shadow-lg transition-shadow" : ""} ${className}`}
      onClick={onClick}
    >
      {children}
    </div>
  )
}

export default Card
